import { SubtableRow } from "./SubtableRow";
import { renderSubtable, SubtableRecordEntry } from "./renderSubtable";
import { OrderLineSerialDto } from "@lib/ShiOneClient";
import { Indentation } from "./rowTypes";

const renderSerialNumbersTable = (
  lineNumber: number,
  rows: OrderLineSerialDto[],
) => {
  const colHeaders = ["Serial Number", "Asset Tag"];
  const rowRecords: SubtableRecordEntry[][] = rows.map((row, index) => [
    { key: `${index}-${row.serialNumber}`, value: row.serialNumber },
    { key: `${index}-${row.assetTag}`, value: row.assetTag },
  ]);
  return renderSubtable(
    colHeaders,
    rowRecords,
    `Line # ${lineNumber}: Serial Numbers`,
  );
};

type Props = Indentation & {
  lineNumber?: number;
  serials: OrderLineSerialDto[] | undefined;
};

export function ProductSerialNumbers({
  xWidth,
  xGap,
  lineNumber,
  serials,
}: Readonly<Props>) {
  if (!lineNumber || !serials?.length) {
    return null;
  }

  return (
    <SubtableRow title="Serial Numbers" xWidth={xWidth} xGap={xGap} colSpan={6}>
      {renderSerialNumbersTable(lineNumber, serials)}
    </SubtableRow>
  );
}

export default ProductSerialNumbers;
